import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { PromotionCode } from '@smartnowx/hcms-plugin-event-manager';
import { BehaviorSubject, catchError, map, of, switchMap } from 'rxjs';
import { PromotionCodeService } from 'src/app/service/promotion-code.service';


@Injectable({ providedIn: 'root' })
export class PromotionCodeValidatorFactory {
  public lastValidPromotionCode$ = new BehaviorSubject<PromotionCode | null>(null);

  constructor(private promotionCodeService: PromotionCodeService) {}

  createValidator(): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const code = (control.value || '').trim();

      if (!code || code.length < 5) {
        this.lastValidPromotionCode$.next(null);
        return of(null); 
      }

      return this.promotionCodeService.validatePromotionCode(code).pipe(
        map((result) => {
          if (!result || (typeof result === 'object' && result.invalid)) {
            this.lastValidPromotionCode$.next(null);
            return { invalidPromotionCode: true, result };
          }

          this.lastValidPromotionCode$.next(result);
          return null;
        }),
        catchError((err) => {
          this.lastValidPromotionCode$.next(null);
          return of({ promotionCodeValidationFailed: true });
        })
      );
    };
  }
}
